<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Diese Webseite verwendet Cookies
  </h4>
</div>
<div class="modal-body">
  <p>
    Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell und
    technisch notwendig, während andere uns helfen, diese Website für Sie zu
    verbessern.
  </p>
  <div class="container">
    <div class="row">
      <div class="form-group">
        <label>
          <input
            [(ngModel)]="required"
            disabled
            type="checkbox"
          />&nbsp;technisch notwendig
        </label>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <label>
          <input [(ngModel)]="tracking" type="checkbox"/>&nbsp;Statistiken
        </label>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <label>
          <input [(ngModel)]="auswahl_merken" type="checkbox"/>&nbsp;Auswahl
          merken
        </label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer flex-row justify-content-between">
  <button (click)="auswahlBestaetigen()" class="btn btn-outline" type="button">
    Auswahl bestätigen
  </button>
  <!--  <button type="button" class="btn btn-primary" (click)="alleAkzeptieren(false)">Alle akzeptieren</button>-->
  <button (click)="alleAkzeptieren(true)" class="btn btn-primary" type="button">
    Alle akzeptieren & merken
  </button>
</div>
<div class="modal-footer flex-row justify-content-center">
  <a href="https://www.sanakey.de/sanakey-portal/impressum" target="_blank"
  >Impressum</a
  >
  <a href="https://www.sanakey.de/sanakey-portal/datenschutz" target="_blank"
  >Datenschutzbestimmungen</a
  >
</div>
